import React, { useEffect, useRef } from 'react';
import './style.css'

export default function Input({type, title, setInput, placeholder, max, onFocusColor, onFocusOutColor}) {
    if(type == null){ type = "text"; }
    if(max == null){ max = null; }

    const inp = useRef(null);
    const tit = useRef(null);

    useEffect(() => {
        inp.current.addEventListener("focusin", onFocus);
        inp.current.addEventListener("focusout", onFocusOut);
    })

    function onFocus(){
        if(onFocusColor){
            tit.current.style.color = onFocusColor;
        }else{
            tit.current.style.color = "black";
        }
    }

    function onFocusOut(){
        setInput(inp.current.value)
        if(onFocusOutColor){
            tit.current.style.color = onFocusOutColor;
        }else{
            tit.current.style.color = "gray";
        }
    }

    return (
        <div className='input-container'>
            <p className='title' ref={tit}>{title}</p>
            <input className='input' type={type} ref={inp} placeholder={placeholder} max={max}></input>
        </div>
    );
}